







import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryFinanceWealthWayDailyList, ExportFinanceWealthWayDaily } from '@/api'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'

@Component({ components: { VQuery, VTable } })
export default class FinanceWealthWayDailyList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    statDateDaterange: [],
    orderBy: 'stat_date desc, net_qty desc',
    statDateTimeScope: '',
    assetType: undefined,
    categoryCode: undefined,
    wayType: undefined,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private tableSelectData: any[] = []
  private queryModels: Array<QueryModel> = [
    { title: '统计日期', param: 'statDateDaterange', type: 'daterange' },
    { title: '资产类型', param: 'assetType', type: 'select', selectData: [
      { label: '绿豆', value: 1 }, { label: '积分', value: 2 },
    ] },
    { title: '大类编码', param: 'categoryCode' },
    { title: '途径类型', param: 'wayType' },
  ]
  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '统计日期', param: 'statDate', width: 120 },
    { title: '资产', param: 'assetType', formatter: (r: any) => r.assetType === 2 ? '积分' : '绿豆' },
    { title: '大类', param: 'categoryName', width: 140 },
    { title: 'way_type', param: 'wayType', width: 80 },
    { title: '途径名称', param: 'wayTypeName', width: 160, overflow: true },
    { title: '入账', param: 'inQty' },
    { title: '出账', param: 'outQty' },
    { title: '净变动', param: 'netQty' },
    { title: '笔数', param: 'txCount' },
    { title: '操作', type: 'operation', width: 100, operation: [
      { title: '钻取', type: 'text', click: this.drillHandle },
    ] },
    { title: '更新时间', param: 'updateTime', formatter: DateFormat, width: 160 },
  ]

  public created() {
    if (this.$route.query.assetType) {
      this.queryParam.assetType = Number(this.$route.query.assetType)
    }
    this.loadData()
  }
  private tableSelectChange(e: any[]) { this.tableSelectData = e }
  private exportHandle() {
    const loading = this.$loading({ lock: true, text: '正在导出', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    const param: any = this.getRequestParam()
    param.limit = ''
    param.startRow = ''
    if (this.tableSelectData.length > 0) param.ids = this.tableSelectData.map(e => e.id)
    ExportFinanceWealthWayDaily(param, '账户流水way_type日汇总.xlsx').finally(() => loading.close())
  }
  private drillHandle(row: any) {
    const day = DateFormat2(row.statDate)
    if (row.assetType === 2) {
      this.$router.push({ path: '/userPointsRecordList', query: { finishTime: day, wayType: String(row.wayType) } })
    } else {
      this.$router.push({ path: '/userWealthRecordList', query: { finishTime: day, type: '3', wayType: String(row.wayType) } })
    }
  }
  public async loadData() {
    const result = await QueryFinanceWealthWayDailyList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam() {
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length > 0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }
  public search() { this.tableCurrntPage = 1; this.loadData() }
  public pageChange(index: number) { this.tableCurrntPage = index; this.loadData() }
  public sizeChange(index: number) { this.tableCurrntPage = 1; this.queryParam.limit = index; this.loadData() }
}
